export default __webpack_public_path__ + "media/images/btn-import-7ab1ac8b1feec93f305aca16ef82f04c.png";